var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.13587 5.6208C6.90417 5.48178 6.61561 5.47814 6.38048 5.61127C6.14534 5.7444 6 5.99372 6 6.26392V10.7639C6 11.0341 6.14534 11.2834 6.38048 11.4165C6.61561 11.5497 6.90417 11.546 7.13587 11.407L10.8859 9.15704C11.1118 9.0215 11.25 8.77737 11.25 8.51392C11.25 8.25047 11.1118 8.00634 10.8859 7.8708L7.13587 5.6208Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.01392C4.41015 2.01392 1.5 4.92407 1.5 8.51392C1.5 12.1038 4.41015 15.0139 8 15.0139C11.5899 15.0139 14.5 12.1038 14.5 8.51392C14.5 4.92407 11.5899 2.01392 8 2.01392ZM0 8.51392C0 4.09564 3.58172 0.513916 8 0.513916C12.4183 0.513916 16 4.09564 16 8.51392C16 12.9322 12.4183 16.5139 8 16.5139C3.58172 16.5139 0 12.9322 0 8.51392Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayicon);
export default __webpack_public_path__ + "static/media/playicon.bc6cccf591bb7d031455433e8ff48648.svg";
export { ForwardRef as ReactComponent };